<template>
  <ul class="p-tasklist-filter">
    <li class="p-tasklist-filter__item">
      <p class="p-tasklist-filter__title">施策別で確認する</p>
      <div class="p-tasklist-filter__content">
        <Select v-model="temp.filter.type" :options="types" size="sm" required>
          <template v-slot:selected="slotProps">
            <span>{{ slotProps.selected.label }}</span>
            <Label
              v-if="slotProps.selected.count || slotProps.selected.count === 0"
              variant="count"
              size="sm"
            >
              {{ slotProps.selected.count }}
            </Label>
          </template>
          <SelectOption
            v-for="(option, index) in types"
            v-model="temp.filter.type"
            :key="index"
            :option="option"
          >
            <span>{{ option.label }}</span>
            <Label
              v-if="option.count || option.count === 0"
              variant="count"
              size="sm"
            >
              {{ option.count }}
            </Label>
          </SelectOption>
        </Select>
      </div>
    </li>
    <li class="p-tasklist-filter__item p-tasklist-filter__item--keyword">
      <p class="p-tasklist-filter__title">キーワード単位で確認する</p>
      <div class="p-tasklist-filter__content">
        <Select
          v-model="temp.filter.keyword"
          :options="keywords"
          size="sm"
          required
        >
          <template v-slot:selected="slotProps">
            <span>{{
              slotProps.selected.label | removeDomain(project.siteUrl)
            }}</span>
            <Label
              v-if="slotProps.selected.count || slotProps.selected.count === 0"
              variant="count"
              size="sm"
            >
              {{ slotProps.selected.count }}
            </Label>
          </template>
          <SelectSearch v-model="search.keyword">
            <p v-if="!filteredKeywords.length">
              条件に合うキーワードがありません。
            </p>
          </SelectSearch>
          <SelectOption
            v-for="(option, index) in filteredKeywords"
            v-model="temp.filter.keyword"
            :key="index"
            :option="option"
          >
            <span>{{ option.label }}</span>
            <Label
              v-if="option.count || option.count === 0"
              variant="count"
              size="sm"
            >
              {{ option.count }}
            </Label>
          </SelectOption>
        </Select>
      </div>
    </li>
    <li class="p-tasklist-filter__item p-tasklist-filter__item--url">
      <p class="p-tasklist-filter__title">URL単位で確認する</p>
      <div class="p-tasklist-filter__content">
        <Select v-model="temp.filter.url" :options="urls" size="sm" required>
          <template v-slot:selected="slotProps">
            <span>{{
              slotProps.selected.label | removeDomain(project.siteUrl)
            }}</span>
            <Label
              v-if="slotProps.selected.count || slotProps.selected.count === 0"
              variant="count"
              size="sm"
            >
              {{ slotProps.selected.count }}
            </Label>
          </template>
          <SelectSearch v-model="search.url">
            <p v-if="!filteredUrls.length && urls.length">
              条件に合うURLがありません。
            </p>
          </SelectSearch>
          <SelectOption
            v-for="(option, index) in filteredUrls"
            v-model="temp.filter.url"
            :key="index"
            :option="option"
          >
            <span>{{ option.label | removeDomain(project.siteUrl) }}</span>
            <Label
              v-if="option.count || option.count === 0"
              variant="count"
              size="sm"
            >
              {{ option.count }}
            </Label>
          </SelectOption>
        </Select>
      </div>
    </li>
    <li class="p-tasklist-filter__item">
      <p class="p-tasklist-filter__title">担当者別で確認する</p>
      <div class="p-tasklist-filter__content">
        <Select
          v-model="temp.filter.operatorUserId"
          :options="operatorUsers"
          size="sm"
          required
        >
          <template v-slot:selected="slotProps">
            <span>{{ slotProps.selected.label }}</span>
            <Label
              v-if="slotProps.selected.count || slotProps.selected.count === 0"
              variant="count"
              size="sm"
            >
              {{ slotProps.selected.count }}
            </Label>
          </template>
          <SelectSearch v-model="search.operatorUserName">
            <p v-if="!filteredOperatorUsers.length && operatorUsers.length">
              条件に合う担当者がいません。
            </p>
          </SelectSearch>
          <SelectOption
            v-for="(option, index) in filteredOperatorUsers"
            v-model="temp.filter.operatorUserId"
            :key="index"
            :option="option"
          >
            <span>{{ option.label }}</span>
            <Label
              v-if="option.count || option.count === 0"
              variant="count"
              size="sm"
            >
              {{ option.count }}
            </Label>
          </SelectOption>
        </Select>
      </div>
    </li>
    <li class="p-tasklist-filter__item">
      <p class="p-tasklist-filter__title">完了予定日で確認する</p>
      <div class="p-tasklist-filter__content">
        <Select
          v-model="temp.filter.executionDateUnit"
          :options="executionDateUnits"
          size="sm"
          required
        >
          <template v-slot:selected="slotProps">
            <span>{{ slotProps.selected.label }}</span>
            <Label
              v-if="slotProps.selected.count || slotProps.selected.count === 0"
              variant="count"
              size="sm"
            >
              {{ slotProps.selected.count }}
            </Label>
          </template>
          <SelectOption
            v-for="(option, index) in executionDateUnits"
            v-model="temp.filter.executionDateUnit"
            :key="index"
            :option="option"
          >
            <span>{{ option.label }}</span>
            <Label
              v-if="option.count || option.count === 0"
              variant="count"
              size="sm"
            >
              {{ option.count }}
            </Label>
          </SelectOption>
        </Select>
      </div>
    </li>
    <li class="p-tasklist-filter__item">
      <p class="p-tasklist-filter__title">完了日で確認する</p>
      <div class="p-tasklist-filter__content">
        <Select
          v-model="temp.filter.typeDoneDateUnit"
          :options="typeDoneDateUnits"
          size="sm"
          required
        >
          <template v-slot:selected="slotProps">
            <span>{{ slotProps.selected.label }}</span>
            <Label
              v-if="slotProps.selected.count || slotProps.selected.count === 0"
              variant="count"
              size="sm"
            >
              {{ slotProps.selected.count }}
            </Label>
          </template>
          <SelectOption
            v-for="(option, index) in typeDoneDateUnits"
            v-model="temp.filter.typeDoneDateUnit"
            :key="index"
            :option="option"
          >
            <span>{{ option.label }}</span>
            <Label
              v-if="option.count || option.count === 0"
              variant="count"
              size="sm"
            >
              {{ option.count }}
            </Label>
          </SelectOption>
        </Select>
      </div>
    </li>
  </ul>
</template>

<script>
import Label from '@/components/Label';
import Select from '@/components/Select';
import SelectOption from '@/components/SelectOption';
import SelectSearch from '@/components/SelectSearch';
import utils from '@/utils';

export default {
  model: {
    prop: 'filter',
    event: 'change'
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Label,
    Select,
    SelectOption,
    SelectSearch
  },
  data() {
    return {
      search: {
        operatorUserName: '',
        url: '',
        keyword: ''
      },
      temp: {
        filter: {
          operatorUserId: this.filter.operatorUserId,
          type: this.filter.type,
          keyword: this.filter.keyword,
          url: this.filter.url,
          executionDateUnit: this.filter.executionDateUnit,
          typeDoneDateUnit: this.filter.typeDoneDateUnit
        }
      },
      dateUnits: [
        {
          label: 'すべて',
          value: ''
        },
        {
          label: '今日',
          value: 'day'
        },
        {
          label: '今週',
          value: 'week'
        },
        {
          label: '今月',
          value: 'month'
        },
        {
          label: '先週',
          value: 'lastWeek'
        },
        {
          label: '来週',
          value: 'nextWeek'
        },
        {
          label: '先月',
          value: 'lastMonth'
        },
        {
          label: '過去3ヶ月',
          value: 'threeMonths'
        },
        {
          label: '過去6ヶ月',
          value: 'sixMonths'
        }
      ]
    };
  },
  computed: {
    filteredOperatorUsers() {
      if (!this.search.operatorUserName) {
        return this.operatorUsers;
      }
      return this.operatorUsers.filter(item => {
        // ユーザーは前方一致
        return item.label.indexOf(this.search.operatorUserName) === 0;
      });
    },
    filteredUrls() {
      if (!this.search.url) {
        return this.urls;
      }
      return this.urls.filter(item => {
        const url = this.$options.filters.removeDomain(
          item.label,
          this.project.siteUrl
        );
        // URLは部分一致
        return url.indexOf(this.search.url) !== -1;
      });
    },
    filteredKeywords() {
      if (!this.search.keyword) {
        return this.keywords;
      }
      return this.keywords.filter(keyword => {
        // 部分一致でキーワードを検索。大文字は小文字に変換。
        const lowerCase = this.search.keyword.toLowerCase();
        return keyword.value.indexOf(lowerCase) !== -1;
      });
    },
    operatorUsers() {
      let items = [];
      const obj = Object.assign({}, this.filter);

      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        // 重複する場合はpushしない
        if (
          !item.operatorUserId ||
          !item.operatorUserName ||
          items.some(user => user.value === item.operatorUserId)
        ) {
          continue;
        }
        obj.operatorUserId = item.operatorUserId;
        const count = this.getCount(obj);
        items.push({
          count: count,
          label: item.operatorUserName,
          value: item.operatorUserId
        });
      }
      items = utils.sortString(items, 'asc', 'label');
      items = utils.sortNumber(items, 'desc', 'count');

      obj.operatorUserId = 'free';
      items.unshift({
        count: this.getCount(obj),
        label: '担当者なし',
        value: 'free'
      });

      obj.operatorUserId = '';
      items.unshift({
        count: this.getCount(obj),
        label: 'すべて',
        value: ''
      });

      return items;
    },
    types() {
      let items = [...this.$store.getters['task/solutionSelect']];
      const obj = Object.assign({}, this.filter);

      items = items.map(item => {
        obj.type = item.value;
        item.count = this.getCount(obj);
        return item;
      });

      obj.type = '';
      items.unshift({
        count: this.getCount(obj),
        label: 'すべて',
        value: ''
      });

      return items;
    },
    keywords() {
      let keywords = [];
      const obj = Object.assign({}, this.filter);

      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        // 重複する場合はpushしない
        if (
          item.keyword &&
          !keywords.some(keyword => keyword.value === item.keyword)
        ) {
          obj.keyword = item.keyword;
          keywords.push({
            count: this.getCount(obj),
            label: item.keyword,
            value: item.keyword
          });
        }
      }
      keywords = utils.sortString(keywords, 'asc', 'label');
      keywords = utils.sortNumber(keywords, 'desc', 'count');

      obj.keyword = '';
      keywords.unshift({
        count: this.getCount(obj),
        label: 'すべて',
        value: ''
      });

      return keywords;
    },
    urls() {
      let items = [];
      const obj = Object.assign({}, this.filter);

      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        // 重複する場合はpushしない
        if (item.url && !items.some(url => url.value === item.url)) {
          obj.url = item.url;
          items.push({
            count: this.getCount(obj),
            label: item.url,
            value: item.url
          });
        }
      }
      items = utils.sortString(items, 'asc', 'label');
      items = utils.sortNumber(items, 'desc', 'count');

      obj.url = '';
      items.unshift({
        count: this.getCount(obj),
        label: 'すべて',
        value: ''
      });

      return items;
    },
    executionDateUnits() {
      const items = this.dateUnits.slice();
      // 完了予定日のみ「期限切れ」を追加
      items.push({
        label: '期限切れ（未完了のみ）',
        value: 'expired'
      });
      return items.map(item => {
        const obj = Object.assign({}, this.filter);
        obj.executionDateUnit = item.value;
        return {
          count: this.getCount(obj),
          label: item.label,
          value: item.value
        };
      });
    },
    typeDoneDateUnits() {
      const items = this.dateUnits.slice();
      return items.map(item => {
        const obj = Object.assign({}, this.filter);
        obj.typeDoneDateUnit = item.value;
        return {
          count: this.getCount(obj),
          label: item.label,
          value: item.value
        };
      });
    }
  },
  watch: {
    'temp.filter': {
      handler(value) {
        this.$emit('change', value);
        this.postAmplitudeEvent();
      },
      deep: true
    }
  },
  methods: {
    getCount(filterObj) {
      return this.items.filter(item => {
        return utils.isMatched(item, filterObj);
      }).length;
    },
    postAmplitudeEvent() {
      // タスクの絞り込み条件をAmplitudeに送信するイベント
      // 絞り込み条件が一つもない場合は送らない。タスクが開かれるたびにイベントが送られて膨大になるため。
      if (
        !this.temp.filter.operatorUserId &&
        !this.temp.filter.type &&
        !this.temp.filter.keyword &&
        !this.temp.filter.url &&
        !this.temp.filter.executionDateUnit &&
        !this.temp.filter.typeDoneDateUnit
      ) {
        return;
      }

      const properties = {
        ...this.temp.filter
      };
      amplitude.getInstance().logEvent('Filter Task List', properties);
    }
  }
};
</script>
